export var SnapshotRecipeStatus;
(function (SnapshotRecipeStatus) {
    SnapshotRecipeStatus["SNAPSHOT_RECIPE_STATUS_DRAFT"] = "DRAFT";
    SnapshotRecipeStatus["SNAPSHOT_RECIPE_STATUS_RESOLVING"] = "RESOLVING";
    SnapshotRecipeStatus["SNAPSHOT_RECIPE_STATUS_READY"] = "READY";
    SnapshotRecipeStatus["SNAPSHOT_RECIPE_STATUS_FAILED"] = "FAILED";
})(SnapshotRecipeStatus || (SnapshotRecipeStatus = {}));
